export const DIALOG = {
  socialLogin: 'socialLogin',
};
